import { makeAppAssetList, makePubAssetList, makeCompanyAssetList } from './api';

export const makeDefaultState = permissions => ({
  permissions,
  isOpen: false,
  history: [],
  activeEntity: {},
  data: {},
  settings: {
    aqv: makeAppAssetList(permissions).reduce((memo, asset) => ({
      ...memo,
      [asset]: {
        pending: true,
        error: false,
      },
    }), {}),
    aqvDetails: {
      pending: true,
      error: false,
    },
    pqv: makePubAssetList(permissions).reduce((memo, asset) => ({
      ...memo,
      [asset]: {
        pending: true,
        error: false,
      },
    }), {}),
    cqv: makeCompanyAssetList(permissions).reduce((memo, asset) => ({
      ...memo,
      [asset]: {
        pending: true,
        error: false,
      },
    }), {}),
  },
  filters: {
    country_iso: ['WW'],
    period: 30,
  },
  additionalParams: {},
});
